import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import { CssBaseline } from '@material-ui/core';
import Header from './components/Header';
import Charity from './components/Charity';

const useStyles  = makeStyles((theme) => ({
  root:
    {
      minHeight: '100vh',
      backgroundImage: `url(${process.env.PUBLIC_URL + '/assets/donation2.jpg'})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      width: '100vw',
      
    }
}));
export default function App(){
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <CssBaseline />
      <Header />
      <Charity />
    </div>
  );
}